export default __webpack_public_path__ + "static/media/vespa.08151673.jpg";